import { store } from '@/firebase'
import {
  CollectionName,
  FSUserActivityStatus
} from '@WombatTechnology/nitte-time-lib'
import {
  collection,
  CollectionReference,
  doc,
  DocumentData
} from 'firebase/firestore'

export class UserActivityStatus {
  static doc(uid: string) {
    return doc<FSUserActivityStatus, DocumentData>(this.collection(), uid)
  }

  static collection() {
    return collection(
      store,
      CollectionName.UserActivityStatuses
    ) as CollectionReference<FSUserActivityStatus>
  }
}
